import React from 'react';
import SlideLayout, { SlideTitle, SlideContent } from '../components/SlideLayout';
import { Sparkles, GitMerge, RefreshCw, Users } from 'lucide-react';

const FutureDirectionsSlide = () => {
  return (
    <SlideLayout maxWidth="6xl">
      <SlideTitle 
        subtitle="Emerging research directions based on 2025 papers"
      >
        Future Directions
      </SlideTitle>
      
      <SlideContent>
        <div className="grid md:grid-cols-2 gap-6">
          {/* PRMs */}
          <div className="slide-card group hover:border-primary/40 transition-all">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 rounded-lg bg-primary/10 group-hover:bg-primary/20 transition-colors">
                <Sparkles className="w-5 h-5 text-primary" />
              </div>
              <span className="font-heading font-semibold text-foreground">Process Reward Models (PRMs)</span>
            </div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Reward each step in reasoning chain, not just final answer</li>
              <li>• Enables better credit assignment</li>
              <li>• Catches errors earlier in reasoning</li>
            </ul>
          </div>
          
          {/* Hybrid systems */}
          <div className="slide-card group hover:border-secondary/40 transition-all">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 rounded-lg bg-secondary/10 group-hover:bg-secondary/20 transition-colors">
                <GitMerge className="w-5 h-5 text-secondary" />
              </div>
              <span className="font-heading font-semibold text-foreground">Hybrid Neuro-Symbolic</span>
            </div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Combine neural LLM with symbolic network simulator</li>
              <li>• LLM generates hypothesis, simulator verifies</li>
              <li>• Iterative refinement based on simulation feedback</li>
            </ul>
          </div>
          
          {/* Continual learning */}
          <div className="slide-card group hover:border-accent/40 transition-all">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 rounded-lg bg-accent/10 group-hover:bg-accent/20 transition-colors">
                <RefreshCw className="w-5 h-5 text-accent" />
              </div>
              <span className="font-heading font-semibold text-foreground">Continual Learning</span>
            </div>
            
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>• Learn from NOC engineer corrections</li>
              <li>• Adapt to specific network environment</li>
              <li>• Privacy-preserving: Keep training data on-premise</li>
            </ul>
          </div>
          
          {/* Multi-agent */}
          <div className="slide-card group hover:border-chart-4/40 transition-all">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 rounded-lg bg-chart-4/10 group-hover:bg-chart-4/20 transition-colors">
                <Users className="w-5 h-5 text-chart-4" />
              </div>
              <span className="font-heading font-semibold text-foreground">Multi-Agent Reasoning</span>
            </div>
            
            <div className="space-y-3">
              <p className="text-sm text-muted-foreground">Network Incident → Parallel Agents:</p>
              <div className="grid grid-cols-2 gap-2 text-xs">
                <span className="px-2 py-1 rounded bg-chart-4/10 text-chart-4">Layer 1-3 specialist</span>
                <span className="px-2 py-1 rounded bg-chart-4/10 text-chart-4">Layer 4-7 specialist</span>
                <span className="px-2 py-1 rounded bg-chart-4/10 text-chart-4">Security specialist</span>
                <span className="px-2 py-1 rounded bg-chart-4/10 text-chart-4">Historical matcher</span>
              </div>
              <p className="text-xs text-muted-foreground">→ Consensus mechanism → Final diagnosis</p>
            </div>
          </div>
        </div>
      </SlideContent>
    </SlideLayout>
  );
};

export default FutureDirectionsSlide;
